import { Button, Col, Row } from "reactstrap";
import { CyMultiChangeToolbar } from "../playlists/CyMultiChangeToolbar";
import {
  DeletableEntry,
  DeleteEntriesModal,
} from "../common/components/multiselectablelist/DeleteEntriesModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useDeleteSongs } from "./useDeleteSongs";

interface Props<E extends DeletableEntry> {
  selectedEntries: readonly E[];
  bucket: string;
  reexecuteQuery?: () => void;
}

export function MultiChangeToolbar<E extends DeletableEntry>({
  selectedEntries,
  bucket,
  reexecuteQuery,
}: Props<E>) {
  const { t } = useTranslation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const { deleteSongs } = useDeleteSongs();

  const handleDeleteSongs = async (entries: readonly E[]) => {
    const ids = entries.map((e) => e.id);

    const success = await deleteSongs(bucket, ids);

    if (reexecuteQuery) {
      //this is not necessary from a functional point of view: `cache.invalidate("SongUB");` will automatically trigger a reload of the songs. However, until the data is loaded, the UI still shows the old list where the item is still there. Reexecuting the query will lead to the loading indicator being shown.
      reexecuteQuery();
    }
    if (!success) {
      alert(t("items.multiChange.deleteError"));
    }
  };

  return (
    <>
      <DeleteEntriesModal<E>
        isModalOpen={isDeleteModalOpen}
        setIsModalOpen={setIsDeleteModalOpen}
        selectedEntries={selectedEntries}
        deleteEntries={handleDeleteSongs}
      />
      <Row
        className={"mb-0 g-2 row-cols-auto "}
        data-cy={CyMultiChangeToolbar.Toolbar}
      >
        <Col>
          <Button
            color="primary"
            onClick={() => setIsDeleteModalOpen(true)}
            data-cy={CyMultiChangeToolbar.DeletePlaylists}
          >
            <FontAwesomeIcon icon={faTrashAlt} /> {t("common.buttons.delete")}
          </Button>
        </Col>
      </Row>
    </>
  );
}
